/* eslint-disable array-callback-return */
import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  Input,
  Form,
  Button,
  Table,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
//redux
import { useSelector, useDispatch } from "react-redux";

import withRouter from "../../Components/Common/withRouter";

//Import Breadcrumb
import Breadcrumbs from "../../Components/Common/Breadcrumb";
import DeleteModal from "../../Components/Common/DeleteModal";

import { users as usersRoles } from "common/data";

import {
  addNewRole,
  updateRole,
  deleteRoles,
  fetchRolesEntity,
} from "slices/roles/thunk";
import { createSelector } from "reselect";
import Spinners from "Components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { getPermissions, getRolesByEntity } from "../../helpers/dataBackend";
import { setAuthorization } from "../../helpers/api_helper";
import { decryptState } from "shared/encryptInfo";
import Select from "react-select";
import { PermissionWrapper } from "shared/permissionWrapper";
import { RootState } from "slices";

const Roles = () => {
  //meta title
  document.title = "System Roles";

  const dispatch = useDispatch<any>();
  const selectProperties = createSelector(
    (state: any) => state.contacts,
    (contact) => ({
      users: usersRoles,
      // loading: contact.loading,
    })
  );

  const { users, loading }: any = useSelector(selectProperties);
  const statusRoles = useSelector((state: RootState) => state.Roles.status);
  const loadingRoles = useSelector((state: RootState) => state.Roles.loading);
  const roles = useSelector((state: RootState) => state.Roles.roles);

  // const roles
  const [isLoading, setLoading] = useState<boolean>(loadingRoles);

  const [roleEdit, setRoleEdit] = useState<any>({});

  const [modal, setModal] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [rolesData, setRolesData] = useState<any>([]);
  const [permissionsData, setPermissionsData] = useState<any>([]);
  const [permissionsDataEdit, setPermissionsDataEdit] = useState<any>([]);
  const [entityId, setEntityId] = useState<any>();
  const [itemsPerPage, setItemsPerPage] = useState<number>(5); // Ajusta este número según lo que necesites
  // TODO - PAGIANCION
  // Estado para la página actual y cantidad de elementos por página
  const [currentPage, setCurrentPage] = useState(1);

  // Cálculos para obtener los elementos de la página actual
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = rolesData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(rolesData.length / itemsPerPage);

  // -- --------------------------------------------------
  //TODO - PERMISOS
  const [selectedPermissions, setSelectedPermissions] = useState<any>([]);

  const [expandedParents, setExpandedParents] = useState({}); // Controla los padres abiertos/cerrados
  // Función para transformar los datos en el formato requerido por react-select
  const transformPermissions = (permissionsData) => {
    let options: any = [];

    permissionsData.forEach((permission) => {
      // Agregamos el padre
      options.push({
        value: permission.id,
        label: `📂 ${permission.name}`, // Ícono para diferenciar padres .replace(/_/g, " ")
        isParent: true,
        children: permission.children || [],
      });

      // Si el padre está expandido, agregamos los hijos
      if (expandedParents[permission.id]) {
        permission.children?.forEach((child) => {
          options.push({
            value: child.id,
            label: `↳ ${child.name.replace(/_/g, " ")}`, // Indentamos hijos
            isChild: true,
            parentId: permission.id,
          });
        });
      }
    });

    return options;
  };

  // Maneja la expansión y contracción de padres
  const toggleParent = (parentId, event) => {
    event.stopPropagation(); // Previene la selección al expandir/cerrar
    setExpandedParents((prev) => ({
      ...prev,
      [parentId]: !prev[parentId],
    }));
  };

  // Manejo de selección
  const handleChange = (selectedOptions) => {
    if (!Array.isArray(selectedOptions)) return;

    let selectedValues = selectedOptions.map((option) => option.value);

    // Asegurar que si un hijo es seleccionado, su padre también lo sea
    selectedOptions.forEach((option) => {
      if (option.isChild && !selectedValues.includes(option.parentId)) {
        selectedValues.push(option.parentId);
      }
    });

    console.log("Permisos seleccionados:", selectedValues);
    setSelectedPermissions(selectedValues);
  };

  // Generamos las opciones dinámicamente
  const options = transformPermissions(permissionsData);

  // --------------------------------------------------

  // Alternar modal
  const toggle = useCallback(() => {
    setModal((prev) => !prev);
  }, []);

  // validation
  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      name: (roleEdit && roleEdit.name) || "",
      description: (roleEdit && roleEdit.description) || "",
      // permissions: (contact && contact.permissions) || "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Your Name"),
      description: Yup.string().required("Please Enter Your description"),
      // permissions: Yup.array().required("Please Enter permissions"),
    }),
    onSubmit: async (values: any) => {
      if (isEdit) {
        const updateUser = {
          id: roleEdit.id,
          name: values.name,
          description: values.description,
          permissions: selectedPermissions,
        };
        await dispatch(updateRole(updateUser));
        setIsEdit(false);
      } else {
        const newRole = {
          name: values["name"],
          description: values["description"],
          permissions: selectedPermissions,
          entity_id: entityId,
        };
        console.log("newRole", newRole);
        await dispatch(addNewRole(newRole));
      }

      await fetchData(); // 🔄 Refresca los datos después de guardar
      validation.resetForm();
      toggle(); // Cierra modal
    },
  });

  //MANEJO PARA EDITAR ROLE
  const handleEditRole = (roleId: number) => {
    const role = rolesData.filter((role: any) => role.id === roleId);
    setRoleEdit({
      id: role[0].id,
      name: role[0].name,
      description: role[0].description,
      permisos: role[0].permissions,
    });
    setPermissionsDataEdit(role[0].permissions);

    setIsEdit(true);
    setModal(true);
  };

  const fetchData = async () => {
    try {
      const token = localStorage.getItem("authUser");
      const userInfo: any = localStorage.getItem("userInfo");
      const decriptedData = decryptState(userInfo);
      setAuthorization(token);
      setEntityId(decriptedData.entity_id);

      const roles = await getRolesByEntity();
      setRolesData(JSON.parse(roles.data));

      const permission = await getPermissions();
      setPermissionsData(JSON.parse(permission.data));

      if (loadingRoles === false) {
        dispatch(fetchRolesEntity());
      }
    } catch (error: any) {
      console.error("Error al obtener datos:", error);
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
    setIsEdit(false);
  }, [dispatch]);

  useEffect(() => {
    setIsEdit(false);
  }, [users]);

  //delete customer
  const [deleteModal, setDeleteModal] = useState<boolean>(false);

  const onClickDelete = (id: any) => {
    dispatch(deleteRoles(id));
    // getData();
  };

  const handleDeleteUser = () => {
    setDeleteModal(false);
  };

  // -- ---------------------------------------------------------------
  // TODO - Personalizamos la forma en que se renderizan las opciones
  // Personalizamos la forma en que se renderizan las opciones
  const CustomOption = (props) => {
    const { data, innerRef, innerProps } = props;
    return (
      <div
        ref={innerRef}
        {...innerProps}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "8px",
          cursor: "pointer",
          backgroundColor: props.isFocused ? "#f0f0f0" : "white",
        }}
        onClick={(event) => {
          if (data.isParent) {
            if (!expandedParents[data.value]) {
              // Si el padre NO está expandido, se selecciona además de expandirse
              innerProps.onClick(event);
            }
            toggleParent(data.value, event);
          } else {
            innerProps.onClick(event); // Permite la selección normal de hijos
          }
        }}
      >
        <span>{data.label}</span>
        {data.isParent && (
          <span
            style={{ marginLeft: "10px", cursor: "pointer" }}
            onClick={(event) => toggleParent(data.value, event)}
          >
            {expandedParents[data.value] ? "▼" : "▶"}{" "}
            {/* Ícono para expandir */}
          </span>
        )}
      </div>
    );
  };
  // -- ---------------------------------------------------------------
  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Roles" breadcrumbItem="Lista Roles" />
          <Row>
            <Col lg="12">
              {isLoading ? (
                <Spinners setLoading={setLoading} />
              ) : (
                <Card>
                  <CardBody>
                    <div className="mb-2 row">
                      <div className="col-sm-2">
                        <select
                          className="form-select pageSize mb-2"
                          onChange={(e) => {
                            setItemsPerPage(parseInt(e.target.value));
                            // console.log(itemsPerPage);
                          }}
                        >
                          <option value="5">Show 5</option>
                          <option value="10">Show 10</option>
                          <option value="20">Show 20</option>
                          <option value="30">Show 30</option>
                          <option value="40">Show 40</option>
                          <option value="50">Show 50</option>
                        </select>
                      </div>
                      <div className="col-sm-4">
                        <Input
                          className="form-control search-box me-2 mb-2 d-inline-block"
                          placeholder="Search..."
                          value=""
                          type="text"
                        />
                      </div>
                      <div className="col-sm-6">
                        <div className="text-sm-end">
                          <PermissionWrapper action={"RO0002"}>
                            <button
                              type="button"
                              className="btn btn-success btn-rounded waves-effect waves-light addContact-modal mb-2 btn btn-secondary"
                              onClick={() => {
                                setModal(true);
                              }}
                            >
                              <i className="mdi mdi-plus me-1"></i> New Role
                            </button>
                          </PermissionWrapper>
                        </div>
                      </div>
                    </div>
                    <div className="table-responsive">
                      <Table className="table mb-0">
                        <thead className="table-light">
                          <tr>
                            <th>#</th>
                            <th>Nombre</th>
                            <th>Descripcion</th>
                            <th>Permisos</th>
                            <th>Disponible</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems.map((item, index) => (
                            <tr key={item.id}>
                              <th scope="row" style={{ width: "50px" }}>
                                {index + 1 + indexOfFirstItem}
                              </th>
                              <td style={{ width: "200px" }}>{item.name}</td>
                              <td style={{ width: "250px" }}>
                                {item.description}
                              </td>
                              <td style={{ width: "600px" }}>
                                {item.permissions.map((permiso, i) => (
                                  <span
                                    className="badge bg-primary me-1"
                                    key={i}
                                  >
                                    {permiso.name}{" "}
                                  </span>
                                ))}
                              </td>

                              <td style={{ width: "100px" }}>
                                {item.enabled ? (
                                  <p className="btn btn-success btn-rounded mb-2 ">
                                    True
                                  </p>
                                ) : (
                                  <p className="btn btn-danger btn-rounded mb-2 ">
                                    False
                                  </p>
                                )}
                              </td>
                              {/* BOTOTNES DE ACCION */}
                              <td style={{ width: "100px" }}>
                                <div className="d-flex gap-3 align-content-center">
                                  {/* EDITAR */}
                                  <PermissionWrapper action={"RO0003"}>
                                    {item.name === "ENTITY_ROLE" ? null : (
                                      <Link
                                        className="text-success"
                                        style={{ fontSize: "25px" }}
                                        to={"#!"}
                                        onClick={() => handleEditRole(item.id)}
                                      >
                                        <i className="bx bxs-edit-alt"></i>
                                      </Link>
                                    )}
                                  </PermissionWrapper>

                                  {/* ELIMINAR */}
                                  <PermissionWrapper action={"RO0004"}>
                                    {item.name === "ENTITY_ROLE" ? null : (
                                      <Link
                                        style={{ fontSize: "25px" }}
                                        className="text-danger"
                                        to={"#!"}
                                      >
                                        {item.enabled ? (
                                          <i
                                            className="bx bxs-trash-alt"
                                            onClick={() =>
                                              onClickDelete(item.id)
                                            }
                                          ></i>
                                        ) : (
                                          <i
                                            className="mdi mdi-reload"
                                            onClick={() =>
                                              onClickDelete(item.id)
                                            }
                                          ></i>
                                        )}
                                      </Link>
                                    )}
                                  </PermissionWrapper>
                                  <PermissionWrapper action={"RO0003"}>
                                    {item.name === "ENTITY_ROLE" ? null : (
                                      <Link
                                        className="text-success"
                                        style={{ fontSize: "25px" }}
                                        to={"#!"}
                                        onClick={() => handleEditRole(item.id)}
                                      >
                                        <i className="mdi mdi-eye-outline"></i>
                                      </Link>
                                    )}
                                  </PermissionWrapper>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>

                      {/* PAGINACION */}
                      <div
                        className="pagination"
                        style={{ marginTop: "20px", textAlign: "center" }}
                      >
                        <button
                          className="btn btn-success btn-rounded mb-2 "
                          onClick={() =>
                            setCurrentPage((prev) => Math.max(prev - 1, 1))
                          }
                          disabled={currentPage === 1}
                          style={{ marginRight: "10px" }}
                        >
                          Prev
                        </button>
                        {Array.from({ length: totalPages }, (_, i) => (
                          <button
                            className="btn btn-danger btn-rounded mb-2 "
                            key={i + 1}
                            onClick={() => setCurrentPage(i + 1)}
                            style={{
                              margin: "0 5px",
                              fontWeight:
                                currentPage === i + 1 ? "bold" : "normal",
                            }}
                          >
                            {i + 1}
                          </button>
                        ))}
                        <button
                          className="btn btn-success btn-rounded mb-2 "
                          onClick={() =>
                            setCurrentPage((prev) =>
                              Math.min(prev + 1, totalPages)
                            )
                          }
                          disabled={currentPage === totalPages}
                          style={{ marginLeft: "10px" }}
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              )}

              {/* MODAL PARA AGREGAR O EDITAR */}
              <Modal isOpen={modal} toggle={toggle}>
                <ModalHeader toggle={toggle} tag="h4">
                  {" "}
                  {!!isEdit ? "Edit User" : "Add Roles"}
                </ModalHeader>
                <ModalBody>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <Row>
                      <Col xs={12}>
                        {/* NAME */}
                        <div className="mb-3">
                          <Label>Name</Label>
                          <Input
                            name="name"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.name || ""}
                            invalid={
                              validation.touched.name && validation.errors.name
                                ? true
                                : false
                            }
                          />
                          {validation.touched.name && validation.errors.name ? (
                            <FormFeedback type="invalid">
                              {validation.errors.name}
                            </FormFeedback>
                          ) : null}
                        </div>
                        {/* DESCRIPTION */}
                        <div className="mb-3">
                          <Label>Description</Label>
                          <Input
                            name="description"
                            label="description"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.description || ""}
                            invalid={
                              validation.touched.description &&
                              validation.errors.description
                                ? true
                                : false
                            }
                          />
                          {validation.touched.description &&
                          validation.errors.description ? (
                            <FormFeedback type="invalid">
                              {" "}
                              {validation.errors.description}{" "}
                            </FormFeedback>
                          ) : null}
                        </div>

                        {/* PERMISOS */}

                        <label className="form-label">Permisos</label>
                        <Select
                          options={options}
                          defaultValue={permissionsDataEdit.map((permiso) => ({
                            value: permiso.id,
                            label: permiso.name,
                          }))}
                          isMulti
                          placeholder="Seleccionar permisos..."
                          // PODEMOS USAR EL VALUE PARA FILTRAR LOS PERMISOS YA SELECCIONADOS
                          // value={options.filter(
                          //   (option) =>
                          //     selectedPermissions.includes(option.value) ||
                          //     (option.isParent &&
                          //       selectedPermissions.some((id) =>
                          //         option.children.some(
                          //           (child) => child.value === id
                          //         )
                          //       ))
                          // )}
                          onChange={handleChange}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          closeMenuOnSelect={false} // Mantiene el menú abierto
                          isSearchable // Habilita la búsqueda
                          hideSelectedOptions={false} // No oculta las opciones seleccionadas
                          components={{ Option: CustomOption }} // Personaliza la visualización de opciones
                          styles={{
                            option: (base, { isSelected, isFocused }) => ({
                              ...base,
                              backgroundColor: isSelected
                                ? "#3b82f6"
                                : isFocused
                                ? "#e9f5ff"
                                : "white",
                              color: isSelected ? "white" : "black",
                              cursor: "pointer",
                              fontWeight: isSelected ? "bold" : "normal",
                              ":hover": {
                                backgroundColor: isSelected
                                  ? "#1e40af"
                                  : "#e9f5ff",
                                color: "black",
                              },
                            }),
                            multiValue: (base) => ({
                              ...base,
                              backgroundColor: "#3b82f6",
                              color: "white",
                              borderRadius: "5px",
                              padding: "2px 5px",
                            }),
                            multiValueLabel: (base) => ({
                              ...base,
                              color: "white",
                              fontWeight: "bold",
                            }),
                            multiValueRemove: (base) => ({
                              ...base,
                              color: "white",
                              ":hover": {
                                backgroundColor: "#1e40af",
                                color: "white",
                              },
                            }),
                          }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <div className="text-end mt-4">
                          <Button
                            type="submit"
                            color="success"
                            className="save-user"
                          >
                            {" "}
                            {!!isEdit ? "Update" : "Add"}{" "}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </ModalBody>
              </Modal>
            </Col>
          </Row>
        </Container>
      </div>
      <ToastContainer />
    </React.Fragment>
  );
};

export default withRouter(Roles);
